import { getUserRoles } from "../../api/auth";

/**
 * Ханш permission levels, mapped onto the existing SFG roles.
 *
 * MANAGE   (ADMIN, MODERATOR) - view, import, create, edit and delete.
 * ADD_VIEW (AUTHOR)           - view, import and create; may not edit or delete.
 * VIEW     (CUSTOMER)         - read only.
 *
 * The backend enforces the same mapping; this module only decides what to render.
 */
export const RATE_VIEW_ROLES = ["ADMIN", "MODERATOR", "AUTHOR", "CUSTOMER"];
export const RATE_ADD_ROLES = ["ADMIN", "MODERATOR", "AUTHOR"];

/** Roles allowed to edit and delete existing rows. Mirrored and enforced on the backend. */
export const RATE_MANAGE_ROLES = ["ADMIN", "MODERATOR"];

export const RATE_LEVEL_VIEW = "VIEW";
export const RATE_LEVEL_ADD_VIEW = "ADD_VIEW";
export const RATE_LEVEL_MANAGE = "MANAGE";

export function getRateAccess(token = localStorage.getItem("access_token")) {
    const roles = getUserRoles(token);

    const canView = roles.some((role) => RATE_VIEW_ROLES.includes(role));
    const canAdd = roles.some((role) => RATE_ADD_ROLES.includes(role));
    const canManage = roles.some((role) => RATE_MANAGE_ROLES.includes(role));

    let permissionLevel = RATE_LEVEL_VIEW;
    if (canManage) permissionLevel = RATE_LEVEL_MANAGE;
    else if (canAdd) permissionLevel = RATE_LEVEL_ADD_VIEW;

    return {
        role: roles[0] || null,
        canView,
        canAdd,
        canEdit: canManage,
        canDelete: canManage,
        permissionLevel,
    };
}
